var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 1.3335V6.66683L8.66675 4.66683L10.6667 6.66683V1.3335",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 13.0002V3.00016C2.66675 2.55814 2.84234 2.13421 3.1549 1.82165C3.46746 1.50909 3.89139 1.3335 4.33341 1.3335H12.6667C12.8436 1.3335 13.0131 1.40373 13.1382 1.52876C13.2632 1.65378 13.3334 1.82335 13.3334 2.00016V14.0002C13.3334 14.177 13.2632 14.3465 13.1382 14.4716C13.0131 14.5966 12.8436 14.6668 12.6667 14.6668H4.33341C3.89139 14.6668 3.46746 14.4912 3.1549 14.1787C2.84234 13.8661 2.66675 13.4422 2.66675 13.0002ZM2.66675 13.0002C2.66675 12.5581 2.84234 12.1342 3.1549 11.8217C3.46746 11.5091 3.89139 11.3335 4.33341 11.3335H13.3334",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWords);
export default __webpack_public_path__ + "static/media/ic_words.407febedcc59c57b1c8b52e53ce6dfaa.svg";
export { ForwardRef as ReactComponent };